import React from "react";
import PropTypes from "prop-types";
import { Modal } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import { styled } from "@mui/system";
import {
  BORDER_PRIMARY,
  BORDER_SECONDARY,
  DISPLAY_FLEX,
  FLEX_ALIGN_CENTER,
  FLEX_DIRECTION_ROW,
  FLEX_JUSTIFY_CENTER,
  MAX_WIDTH,
  TEXT_ALIGN_LEFT,
} from "../config/styles";
import { Typography } from "@mui/material";
import { colors } from "../config/colors";

const DeleteReportStyled = styled(Modal)(({ theme }) => ({
  width: "408px",
  margin: "0 auto",
  "& .custom-modal": {
    width: "408px !important",
    margin: "0 auto !important",
  },
  "& .modal-header": {
    backgroundColor: theme.palette.secondary.contrastText,
    padding: "16px 24px",
    display: DISPLAY_FLEX,
    borderBottom: BORDER_SECONDARY,
  },
  "& .modal-header-wrapper": {
    display: DISPLAY_FLEX,
    flexDirection: FLEX_DIRECTION_ROW,
    justifyContent: FLEX_JUSTIFY_CENTER,
    alignItems: FLEX_ALIGN_CENTER,
    width: MAX_WIDTH,
    paddingTop: "8px",
  },
  "& .modal-body": {
    padding: "20px",
    textAlign: "left",
    fontSize: "16px",
    color: theme.palette.text.primary,
  },
  "& .button-style": {
    width: "360px",
    margin: "24px auto",
    padding: "8px 16px",
    gap: "8px",
    height: "36px",
    backgroundColor: theme.palette.secondary.contrastText,
    color: colors.warning,
    borderRadius: "4px",
    fontSize: "14px",
    fontWeight: "bold",
    border: BORDER_PRIMARY,
    "&:hover": {
      backgroundColor: theme.palette.primary.dark,
    },
  },
}));

export const DeleteReport = ({ show, onHide, title, reportName, onDone }) => {
  return (
    <DeleteReportStyled
      show={show}
      onHide={onHide}
      centered
      contentClassName="custom-modal"
    >
      <Modal.Header bsPrefix="modal-header" closeButton>
        <Typography variant="body2">{title}</Typography>
      </Modal.Header>

      <Modal.Body className="p-4">
        <Typography
          variant="h4"
          className="w-100"
          component={"div"}
          sx={{ textAlign: TEXT_ALIGN_LEFT }}
        >
          Custom Report Name
        </Typography>
        <Typography
          variant="subtitle2"
          className="w-100"
          component={"div"}
          sx={{ textAlign: TEXT_ALIGN_LEFT }}
        >
          {reportName}
        </Typography>
        <Typography
          variant="body1"
          className="w-100 mt-3"
          component={"div"}
          sx={{ textAlign: TEXT_ALIGN_LEFT }}
        >
          This will permanentely delete the custom report. Do you want to
          proceed?
        </Typography>
      </Modal.Body>
      <Modal.Footer className="d-flex justify-content-center">
        <Button className="button-style" onClick={onDone}>
          Delete
        </Button>
      </Modal.Footer>
    </DeleteReportStyled>
  );
};
DeleteReport.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  title: PropTypes.string,
  reportName: PropTypes.string,
  onDone: PropTypes.func.isRequired,
};
